import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC } from 'react';
import { IconCheckCircle, IconFailCircle } from '../Icon';

interface Props {
  isSuccess: boolean;
}

export const SuccessFailIcon: FC<Props> = ({ isSuccess }) => {
  return isSuccess ? (
    <IconCheckCircle color={RacemapColors.DarkGreen} />
  ) : (
    <IconFailCircle color={RacemapColors.BaseRed} />
  );
};
